<template>
  <div class="w-full 2xl:w-[90%] mx-auto p-2 md:p-4 lg:p-12 relative">
    <!-- popup section -->
    <div
      v-if="showPopup"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75"
    >
      <div class="relative w-full max-w-md h-auto">
        <div class="relative bg-white rounded-lg shadow-lg">
          <button
            @click="toggleModal"
            class="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
          >
            <svg
              class="w-3 h-3 text-slate-500"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
          </button>
          <div class="p-4 md:p-5 text-center">
            <svg
              class="mx-auto mb-4 text-slate-500 w-12 h-12"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <h3 class="mb-5 text-lg font-medium text-gray-800">
              {{ $t("are-you-sure-you-want-to-proceed") }}
            </h3>
            <p class="mb-5 text-sm font-medium text-gray-800">
              <strong>{{ $t("important") }}</strong>
              {{
                $t(
                  "if-you-choose-to-upgrade-or-downgrade-your-subscription-you-will-lose-any-remaining-balance-from-your-current-offer-all-unused-coins-will-be-forfeited-please-consider-your-options-carefully-before-making-a-change"
                )
              }}
            </p>

            <button
              @click="
                () => {
                  togglePaymentChoice();
                }
              "
              class="py-2.5 px-5 ms-3 text-sm font-medium text-white border rounded-lg bg-red-600"
            >
              {{ $t("yes-im-sure") }}
            </button>
            <button
              @click="toggleModal"
              class="py-2.5 px-5 ms-3 text-sm font-medium text-white border rounded-lg bg-slate-800"
            >
              {{ $t("no-cancel") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="pricing" class="mx-auto text-center">
      <h2
        class="mb-2 md:mb-4 text-lg md:text-2xl lg:text-4xl tracking-tight font-bold text-[#061B44]"
      >
        {{ $t("choose-the-right-plan-for-you") }}
      </h2>
      <p
        class="font-light text-gray-500 text-sm sm:text-xl max-w-screen-md mx-auto"
      >
        {{
          $t(
            "whether-casual-or-professional-our-plans-offer-seamless-communication-and-superior-translation-accuracy-upgrade-to-advanced-options-for-unmatched-quality-and-dedicated-support"
          )
        }}
      </p>
      <p
        class="font-light text-gray-500 text-sm sm:text-base max-w-screen-md mx-auto mt-2 md:mt-3"
      >
        {{ $t("pricing-one-time-hero") }}
      </p>
    </div>
    <!-- Plans + pricing UI (student discount UI is commented inside PricingComponent) -->
    <PricingComponent />
    <!-- <div
      v-if="!isMonthlyTab"
      class="mt-10 border-[1px] border-slate-200 rounded-md w-full flex flex-col items-center py-4 px-3"
    >
      <p class="text-sm font-normal text-slate-900">
        {{ $t("pay-as-you-go") }}
      </p>
      <p class="text-2xl font-bold text-slate-900 my-1">
        {{ $t("consume-as-you-pay") }}
      </p>
      <p class="text-sm font-normal text-slate-500">
        {{ $t("purchase-credit-in-advance-and-use") }}
      </p>
      <div class="flex flex-wrap gap-3 mt-4 mx-auto">
        <div class="flex flex-col space-y-2">
          <p class="text-md font-medium text-slate-900">
            {{ $t("deposit-system") }}
          </p>
          <p class="text-sm font-normal text-slate-500">
            {{ $t("add-funds-to-your-account") }}
          </p>
        </div>
        <div class="flex flex-col space-y-2">
          <p class="text-md font-medium text-slate-900">
            {{ $t("flexible-usage") }}
          </p>
          <p class="text-sm font-normal text-slate-500">
            {{ $t("no-monthly-commitment-use-any") }}
          </p>
        </div>
        <div class="flex flex-col space-y-2">
          <p class="text-md font-medium text-slate-900">
            {{ $t("usage-transparency") }}
          </p>
          <p class="text-sm font-normal text-slate-500">
            {{ $t("real-time-dashboard-shows") }}
          </p>
        </div>
      </div>
      <button
        @click="togglePayasyougoChoice"
        class="text-white bg-slate-900 border font-medium rounded-lg text-sm px-10 py-2.5 text-center mt-6"
      >
        {{ $t("add-credit") }}
      </button>
    </div> -->
    <div id="contact" class="my-8 text-center w-[90%] md:w-[80%] mx-auto mt-20">
      <p class="text-xl lg:text-3xl font-semibold text-slate-800 pb-6">
        {{ $t("interested-in-the-enterprise-package") }}
      </p>
      <p class="text-lg text-gray-500 font-medium mb-6">
        {{
          $t(
            "contact-our-sales-team-for-a-personalized-offer-tailored-to-your-organizations-needs-well-create-a-custom-solution-with-exceptional-pricing-help-you-estimate-your-usage-and-charge-your-account-with-a-high-initial-balance"
          )
        }}
      </p>
      <p class="text-lg font-bold text-blue-600 mb-4">
        <a href="mailto:contactus@subtitles.tech" class="hover:underline"
          >contactus@subtitles.tech</a
        >
      </p>
      <p class="mt-4 text-lg text-gray-500 font-medium">
        {{ $t("our-sales-team-will-provide-full-assistance-inc") }}
      </p>
    </div>
    <div
      class="flex flex-col w-full mx-auto justify-center items-center pt-20 pb-10"
    >
      <p class="text-xl lg:text-3xl font-semibold text-slate-800 pb-2 md:pb-6">
        {{ $t("frequently-asked-questions") }}
      </p>
      <p class="text-sm md:text-lg font-medium pb-2 md:pb-6 text-slate-500">
        {{ $t("we-have-some-answers-to-your-questions") }}
      </p>

      <div
        v-for="(faq, index) in faqs"
        :key="index"
        class="w-full md:w-[80%] lg:w-[70%] xl:w-[50%]"
      >
        <div
          @click="toggleFaq(index)"
          class="cursor-pointer flex flex-col justify-between items-center py-6 border-b border-slate-300"
        >
          <div class="flex flex-row w-full justify-between items-center">
            <p class="text-base md:text-lg font-semibold">{{ faq.question }}</p>
            <svg
              v-if="activeIndex === index"
              class="w-3 h-3 transition-transform duration-300"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                d="M23.245 20l-11.245-14.374-11.219 14.374-.781-.619 12-15.381 12 15.391-.755.609z"
              />
            </svg>
            <svg
              v-else
              class="w-3 h-3 transform rotate-180 transition-transform duration-300"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                d="M23.245 20l-11.245-14.374-11.219 14.374-.781-.619 12-15.381 12 15.391-.755.609z"
              />
            </svg>
          </div>
          <div
            v-if="activeIndex === index"
            class="py-4 text-slate-500 text-base"
          >
            {{ faq.answer }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import {
  API_BASE_URL,
  CREATECHECKOUT,
  supportEmail,
  CREATECHECKOUTPAYPAL,
  PRODUCTIONFRONTEND,
  BUYWITHBALANCE,
  CREATESUBSPAYPAL,
} from "../utils/appConst";
import { useAuthStore } from "../store/auth";
import { toast } from "vue3-toastify";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useUserProfile } from "../store/userProfile";
import PricingComponent from "../components/pricing_component.vue";
import { useHead } from "@vueuse/head";
import { onMounted } from "vue";

const { t, locale } = useI18n();
const router = useRouter();
const authStore = useAuthStore();
const userStore = useUserProfile();
const createCheckout = `${API_BASE_URL}${CREATECHECKOUT}`;
const createCheckoutPpl = `${API_BASE_URL}${CREATECHECKOUTPAYPAL}`;
const createSubscriptionPpl = `${API_BASE_URL}${CREATESUBSPAYPAL}`;
const buyWithBalancePpl = `${API_BASE_URL}${BUYWITHBALANCE}`;
const showPopup = ref<boolean>(false);
const isBannedArea = ref<boolean>(false);
const paymentsChoicePopup = ref<boolean>(false);
const payasyougoPopup = ref<boolean>(false);
const selectedDepositValue = ref<number>(5);
const isStudent = ref<boolean>(false);
const isMonthlyTab = ref<boolean>(true);
const selectedMethod = ref("paypal");
const bannedCountries: string[] = [];
const insufficientFunds = computed(
  () =>
    userStore.userDeposit <
    authStore.products.find(
      (e) =>
        e.subscriptionType === selectedOffer.value &&
        !e.stripe &&
        e.isStudent === isStudent.value
    )?.price!
);

onMounted(() => {
  checkBannedArea();
});


const faqs = computed(() => [
  {
    question: t("what-is-subtitles"),
    answer: t("subtitles-is-a-web-and-mobile-application-desig"),
  },
  {
    question: t("how-do-i-use-subtitles"),
    answer: t("to-use-subtitles-simply-upload"),
  },
  {
    question: t("what-formats-can-i-export-with-subtitles"),
    answer: t("subtitles-allows-you-to-export-in-m"),
  },
  {
    question: t("how-does-subtitles-ensure-high-quality-translations"),
    answer: t("subtitles-uses-advanced-ai-to-deliver-hi"),
  },
  {
    question: t("why-should-i-use-subtitles"),
    answer: t("subtitles-offers-a-user-friendly-interfa"),
  },
]);

const activeIndex = ref<number | null>(null);
const selectedOffer = ref<string>("");

const toggleFaq = (index: number) => {
  activeIndex.value = activeIndex.value === index ? null : index;
};

const togglePaymentChoice = () => {
  paymentsChoicePopup.value = !paymentsChoicePopup.value;
};

const checkBannedArea = async () => {
  try {
    const res = await fetch("https://www.cloudflare.com/cdn-cgi/trace");
    const text = await res.text();
    const match = text.match(/loc=(\w+)/);
    const countryCode = match ? match[1] : "US";
    isBannedArea.value = bannedCountries.includes(countryCode);
  } catch (error) {
    console.error("Network error:", error);
  }
};

const toggleModal = () => {
  showPopup.value = !showPopup.value;
  document.body.classList.toggle("modal-open", showPopup.value);
};

function getProductPrice(pack: string): number {
  return (
    authStore.products.find(
      (e) => e.subscriptionType === pack && e.isStudent === isStudent.value
    )?.price || 0
  );
}

interface FAQ {
  question: string;
  answer: string;
}

export interface Product {
  productId: string;
  price: number;
  subscriptionType: string;
  stripe: boolean;
  isStudent: boolean;
}

useHead({
  title:
    "Pricing - Subtitles Tech | Affordable AI-Powered Transcription & Translation Plans",
  meta: [
    {
      name: "description",
      content:
        "Explore affordable pricing plans for AI-powered transcription and translation services at Subtitles Tech. Convert audio to text, video to text, and generate subtitles easily. Choose the perfect plan for your needs.",
    },
    {
      name: "keywords",
      content:
        "transcription pricing, audio to text pricing, video to text pricing, affordable subtitles generator, AI transcription pricing, automatic subtitles pricing, YouTube transcription pricing, speech-to-text pricing, translation pricing, AI-powered transcription pricing, Captioning service pricing, Closed captioning pricing, Multilingual subtitles pricing, Pay-as-you-go transcription, Voice-to-text pricing, Transcription in 140 languages, AI-based captioning pricing, Multilingual accessibility services pricing, Translate captions pricing",
    },
    {
      property: "og:title",
      content:
        "Pricing - Subtitles Tech | Affordable AI-Powered Transcription & Translation Plans",
    },
    {
      property: "og:description",
      content:
        "Explore affordable pricing plans for AI-powered transcription and translation services at Subtitles Tech. Convert audio to text, video to text, and generate subtitles easily. Choose the perfect plan for your needs.",
    },
    {
      property: "og:image",
      content: `${PRODUCTIONFRONTEND}assets/Icon-D2oZLO0r.png`,
    },
    {
      property: "og:url",
      content: `${PRODUCTIONFRONTEND}pricing`,
    },
  ],
  link: [
    {
      rel: "canonical",
      href: `${PRODUCTIONFRONTEND}pricing`,
    },
  ],
});
</script>

<style scoped>
body.modal-open {
  overflow: hidden;
}
</style>
